/*
 * Filename: CQFormulaFieldRuleController.ts
 * Description: Controller for Formula field rule
 */

import { CQAppConstant } from '../../../app-constants';
import { FormRuleController } from '../form-rule.controller';

interface IFormulaRuleModalState {
    setObject : any[]
    additionalFields:string[];
    fieldWisePicklistValues:any[];
    selectedReferenceFields:any[];
    shouldSkip: boolean
}
export class CQFormulaFieldRuleController extends FormRuleController {
    public ruleJSON: any = {};

    constructor(type: string, ruleObject: IFormulaRuleModalState) {
        super();
        this.formRuleJson(type, ruleObject);
    }

    /**
     * @private
     * @memberof CQFormulaFieldRuleController
     */
    private formRuleJson = (type: string, formulaFieldRuleData: IFormulaRuleModalState) => {

        let formulaFieldRule: any = this.formRuleFilter(formulaFieldRuleData);

        formulaFieldRule = { [`Formula Field - ${type}`]: formulaFieldRule };
        this.ruleJSON = formulaFieldRule;
        return this.ruleJSON;
    }

    /**
    * @memberof CQFormulaFieldRuleController
    */
    public formRuleFilter = (formulaFieldRuleData: IFormulaRuleModalState) => {
        
        const formulaFieldRuleObj:any = {};
        const setObjects: any[] = [];

        formulaFieldRuleData.setObject.forEach((formulaSection: any) => {
            const fields: string[] = [];
            const formulaObject = { fields, filter: '', action: {} };
            formulaSection.addedCriterias.forEach((criteria: any) => {
                const fieldName = criteria.field.split('-')[0];
                if(!formulaObject.fields.includes(fieldName)){
                    formulaObject.fields.push(fieldName);
                }
                
                if (criteria.isDynamic 
                    && criteria.operator !== CQAppConstant.EXISTS
                    && criteria.operator !== CQAppConstant.ISEMPTY) {
                    const fieldName = criteria.compareTo.split('-')[0];
                    if(!formulaObject.fields.includes(fieldName)){
                        formulaObject.fields.push(fieldName);
                    }
                }
            });
            
            if(formulaSection.shouldSkip){
                formulaObject.filter = "true";
            }else{
                formulaObject.filter = this.formFilterString(formulaSection.complexLogicQuery, formulaSection.addedCriterias);
            }
            formulaObject.action = formulaSection.action;
            formulaObject.fields = Array.from(new Set(formulaObject.fields));
            setObjects.push(formulaObject);
        });
        formulaFieldRuleObj.setObject = setObjects;
        return formulaFieldRuleObj;
    }

}

